/**
 * Mobile Menu Localization Picker JavaScript
 * Separate from header picker - prevents menu drawer from closing
 * Must run BEFORE v3 top bar JavaScript to intercept clicks
 */
(function() {
  'use strict';
  
  // Use IIFE with immediate execution to run as early as possible
  (function preventMenuClose() {
    // CRITICAL: Stop ALL clicks within mobile picker to prevent menu drawer from closing
    // LocalizationForm will still work because it's attached directly to button elements
    
    let isProcessingClick = false; // Flag to prevent infinite loops
    
    // Capture phase: Stop propagation IMMEDIATELY for ALL clicks in mobile picker
    // This must run BEFORE menu drawer's button handlers
    // Use a named function so we can ensure it runs first
    function captureHandler(e) {
      // Prevent infinite loops - skip if we're already processing
      if (isProcessingClick) {
        return;
      }
      
      const isInMobilePicker = e.target.closest('.mobile-menu-localization-picker');
      const isInMobilePickerContainer = e.target.closest('.menu-drawer__localization-picker');
      const isPickerButton = e.target.closest('.mobile-menu-localization-picker__button');
      
      if (isInMobilePicker || isInMobilePickerContainer) {
        // Check if it's a link in the dropdown (should allow form submission)
        const isDropdownLink = e.target.closest('.mobile-menu-localization-picker__link') || 
                               e.target.closest('a.disclosure__link');
        
        if (isDropdownLink) {
          // Allow link clicks to proceed - LocalizationForm needs these to submit the form
          // But still prevent menu drawer from closing by stopping propagation in bubble phase
          console.log('✅ [Mobile Picker] Allowing dropdown link click for form submission');
          return; // Don't stop propagation here - let LocalizationForm handle it
        }
        
        // For button clicks, we need to be careful - stop immediate propagation
        // to prevent menu drawer's onCloseButtonClick, but let LocalizationForm work
        if (isPickerButton) {
          // Mark that we're processing
          isProcessingClick = true;
          
          // Stop immediate propagation to prevent menu drawer's onCloseButtonClick
          e.stopImmediatePropagation();
          e.stopPropagation();
          console.log('🛑 [Mobile Picker] Stopped button click (capture) - preventing menu close');
          
          // Manually toggle the dropdown by directly manipulating the DOM
          // This avoids triggering events that would cause infinite loops
          const listId = isPickerButton.getAttribute('aria-controls');
          if (listId) {
            const list = document.getElementById(listId);
            if (list) {
              const isHidden = list.hasAttribute('hidden');
              
              // Close the other dropdown if it's open
              const otherListId = listId === 'MobileMenuCountryList' ? 'MobileMenuLanguageList' : 'MobileMenuCountryList';
              const otherList = document.getElementById(otherListId);
              const otherButton = document.querySelector(`[aria-controls="${otherListId}"]`);
              
              if (otherList && !otherList.hasAttribute('hidden')) {
                otherList.setAttribute('hidden', '');
                if (otherButton) {
                  otherButton.setAttribute('aria-expanded', 'false');
                }
                console.log('✅ [Mobile Picker] Closed other dropdown:', otherListId);
              }
              
              if (isHidden) {
                list.removeAttribute('hidden');
                isPickerButton.setAttribute('aria-expanded', 'true');
                console.log('✅ [Mobile Picker] Opened dropdown:', listId);
              } else {
                list.setAttribute('hidden', '');
                isPickerButton.setAttribute('aria-expanded', 'false');
                console.log('✅ [Mobile Picker] Closed dropdown:', listId);
              }
            }
          }
          
          // Reset flag after a short delay
          setTimeout(() => {
            isProcessingClick = false;
          }, 50);
        } else {
          // For other non-button, non-link clicks, stop everything
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log('🛑 [Mobile Picker] Stopped non-button click (capture)', e.target.tagName);
        }
      }
    }
    
    // Add with highest priority - use capture phase and make sure it runs first
    // Add it to window as well to catch it even earlier
    window.addEventListener('click', captureHandler, true); // Capture phase - runs FIRST
    document.addEventListener('click', captureHandler, true); // Capture phase - runs FIRST
    
    // Bubble phase: Also stop propagation as backup
    function bubbleHandler(e) {
      // Skip if we're processing a button click
      if (isProcessingClick) {
        return;
      }
      
      const isInMobilePicker = e.target.closest('.mobile-menu-localization-picker');
      const isInMobilePickerContainer = e.target.closest('.menu-drawer__localization-picker');
      
      if (isInMobilePicker || isInMobilePickerContainer) {
        // Check if it's a link in the dropdown - allow it to submit the form
        const isDropdownLink = e.target.closest('.mobile-menu-localization-picker__link') || 
                               e.target.closest('a.disclosure__link');
        
        if (isDropdownLink) {
          // Allow the form to submit, but prevent menu drawer from closing
          // Stop propagation after LocalizationForm has handled it
          e.stopPropagation();
          console.log('✅ [Mobile Picker] Allowed link click, stopping propagation to prevent menu close');
          return;
        }
        
        // For other clicks, stop propagation in bubble phase too
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('🛑 [Mobile Picker] Stopped click propagation (bubble)', e.target.tagName, e.target.className);
      }
    }
    
    window.addEventListener('click', bubbleHandler, false); // Bubble phase
    document.addEventListener('click', bubbleHandler, false); // Bubble phase
    
    // Prevent focusout from closing menu drawer
    document.addEventListener('focusout', (e) => {
      const isInMobilePicker = e.target.closest('.mobile-menu-localization-picker');
      const isInMobilePickerContainer = e.target.closest('.menu-drawer__localization-picker');
      
      if (isInMobilePicker || isInMobilePickerContainer) {
        // Prevent focusout from triggering menu drawer close
        e.stopPropagation();
        e.stopImmediatePropagation();
        console.log('🛑 [Mobile Picker] Stopped focusout');
      }
    }, true);
    
    // Also add handler directly on the picker container with highest priority
    function addContainerHandler() {
      const menuDrawerPicker = document.querySelector('.menu-drawer__localization-picker');
      if (menuDrawerPicker) {
        // Capture phase handler - runs FIRST
        menuDrawerPicker.addEventListener('click', (e) => {
          // Allow dropdown links to proceed
          const isDropdownLink = e.target.closest('.mobile-menu-localization-picker__link') || 
                                 e.target.closest('a.disclosure__link');
          if (!isDropdownLink) {
            e.stopPropagation();
            console.log('🛑 [Mobile Picker] Container stopped click (capture)', e.target);
          }
        }, true);
        
        // Bubble phase handler
        menuDrawerPicker.addEventListener('click', (e) => {
          // Allow dropdown links to proceed
          const isDropdownLink = e.target.closest('.mobile-menu-localization-picker__link') || 
                                 e.target.closest('a.disclosure__link');
          if (!isDropdownLink) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            console.log('🛑 [Mobile Picker] Container stopped click (bubble)', e.target);
          }
        }, false);
      }
    }
    
    // Run immediately and multiple times to catch dynamically loaded content
    addContainerHandler();
    setTimeout(addContainerHandler, 50);
    setTimeout(addContainerHandler, 100);
    setTimeout(addContainerHandler, 500);
    setTimeout(addContainerHandler, 1000);
  })();
  
  // No red circle needed - dropdowns will show instead
})();

